import { createActionConst } from '../../../../utils/action.utils';

const MEETING_TASK_NAMESPACE = 'MEETING_TASK';

export const GET_MEETING_TASKS = createActionConst(MEETING_TASK_NAMESPACE, 'GET_MEETING_TASKS');

export const STORE_MEETING_TASKS = createActionConst(MEETING_TASK_NAMESPACE, 'STORE_MEETING_TASKS');
export const CLEAR_MEETING_TASKS = createActionConst(MEETING_TASK_NAMESPACE, 'CLEAR_MEETING_TASKS');
